import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split'
})
export class SplitPipe implements PipeTransform {
  transform(input:string):string{
  return input.split(' ')[0]
 }
}

@Pipe({
  name: 'rest'
})
export class RestPipe implements PipeTransform {
  transform(input:string):string{

    var str = input.split(' ');
    var res = "";
    for (let index = 1; index < str.length; index++) {
      res += " "+str[index];
    }

  return res;
 }
}

@Pipe({
  name: 'truncate'
 })
 
 export class TruncatePipe implements PipeTransform {
 
 transform(value: string, args: any[]): string {
     const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
     const trail = args.length > 1 ? args[1] : '...';
     return value.length > limit ? value.substring(0, limit) + trail : value;
    }
 }